import { Meeting } from '../types/meetings';
import { MeetingGroup } from '../types/groups';

export async function translateMeeting(
  meeting: Meeting,
  _targetLanguage: string
): Promise<Meeting> {
  return meeting;
}

export async function translateMeetings(
  meetings: Meeting[],
  _targetLanguage: string
): Promise<Meeting[]> {
  return meetings;
}

export async function translateMeetingField(
  text: string,
  _targetLanguage: string
): Promise<string> {
  return text;
}

export async function translateGroup(
  group: MeetingGroup,
  _targetLanguage: string
): Promise<MeetingGroup> {
  return group;
}

export async function translateGroups(
  groups: MeetingGroup[],
  _targetLanguage: string
): Promise<MeetingGroup[]> {
  return groups;
}
